export default __webpack_public_path__ + "static/media/due_task.929d9453.svg";